var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapPin01 = function SvgMapPin01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "map_pin-01_svg2__a",
    x1: 24.03,
    x2: 184.24,
    y1: 192.88,
    y2: 32.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#map_pin-01_svg2__a",
    id: "map_pin-01_svg2__b",
    x1: -2,
    x2: 158.21,
    y1: 166.85,
    y2: 6.63
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M133.4 132.14c21.27-33.38 18.6-29.21 19.21-30.08 7.75-10.93 11.84-23.79 11.84-37.2C164.46 29.29 135.6 0 100 0S35.54 29.23 35.54 64.85c0 13.4 4.18 26.6 12.18 37.67l18.88 29.62c-20.19 3.1-54.51 12.35-54.51 32.7 0 7.42 4.84 17.99 27.91 26.23 16.11 5.75 37.41 8.92 59.99 8.92 42.2 0 87.9-11.9 87.9-35.16 0-20.36-34.26-29.59-54.49-32.7ZM57.51 96.08h.01c-.06-.1-.13-.2-.2-.3a52.57 52.57 0 0 1-10.05-30.93c0-29.3 23.6-53.13 52.74-53.13s52.74 23.83 52.74 53.13c0 10.93-3.33 21.42-9.63 30.34-.56.74 2.38-3.83-43.11 67.56L57.53 96.08ZM100 188.3c-46.09 0-76.18-13.55-76.18-23.44 0-6.65 15.46-17.58 49.71-21.84l21.52 33.77c1.08 1.69 2.94 2.71 4.94 2.71s3.87-1.02 4.94-2.71l21.52-33.77c34.25 4.26 49.71 15.19 49.71 21.84 0 9.81-29.81 23.44-76.18 23.44Z",
    style: {
      fill: "url(#map_pin-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3 64.85c0-16.15-13.14-29.3-29.3-29.3s-29.3 13.14-29.3 29.3 13.14 29.3 29.3 29.3 29.3-13.14 29.3-29.3m-46.88 0c0-9.69 7.89-17.58 17.58-17.58s17.58 7.89 17.58 17.58-7.89 17.58-17.58 17.58-17.58-7.89-17.58-17.58",
    style: {
      fill: "url(#map_pin-01_svg2__b)"
    }
  }));
};
export default SvgMapPin01;